import { graphql, useStaticQuery } from 'gatsby'

export const faqMdxFile = graphql`
  fragment faqMdxFile on MdxConnection {
    edges {
      node {
        id
        body
        excerpt
        rawBody
        frontmatter {
          title
          order
        }
      }
    }
  }
`

/**
 * @property en_MY
 * @property es_CL
 * @property es_PE
 * @property pt_BR
 * @property es_EC
 * @property es_MX
 *
 * Dont use markdown in the mdx files because it can break google rich results
 */
export const faqQuery = graphql`
  query faqQuery {
    en_MY: allMdx(
      filter: { fileAbsolutePath: { regex: "/en-my/faq-items/" } }
    ) {
      ...faqMdxFile
    }
    es_CL: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-cl/faq-items/" } }
    ) {
      ...faqMdxFile
    }
    es_CO: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-co/faq-items/" } }
    ) {
      ...faqMdxFile
    }
    es_PE: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-pe/faq-items/" } }
    ) {
      ...faqMdxFile
    }
    pt_BR: allMdx(
      filter: { fileAbsolutePath: { regex: "/pt-br/faq-items/" } }
    ) {
      ...faqMdxFile
    }
    es_EC: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-ec/faq-items/" } }
    ) {
      ...faqMdxFile
    }
    es_MX: allMdx(
      filter: { fileAbsolutePath: { regex: "/es-mx/faq-items/" } }
    ) {
      ...faqMdxFile
    }
  }
`

const useFaqItems = () => useStaticQuery(faqQuery)

export default useFaqItems
